import {GetServiceCenterUrl} from 'domain/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {RemoteGetServiceCenterUrl} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {ExternalLinkPoint} from 'main/factories/usecases/endpoints';

export const makeGetServiceCenterUrl = (): GetServiceCenterUrl =>
	new RemoteGetServiceCenterUrl(
		makeBFFApiUrl(ExternalLinkPoint.serviceCenter),
		makeAuthorizeHttpClientDecorator(),
	);
